import { useState, useEffect, useRef } from 'react';

export const useAnimatedValue = (value, duration = 300) => {
    const [isAnimating, setIsAnimating] = useState(false);
    const previousValue = useRef(value);
    
    useEffect(() => {
        if (previousValue.current !== value && value !== null && value !== undefined) {
            setIsAnimating(true);
            const timer = setTimeout(() => setIsAnimating(false), duration);
            previousValue.current = value;
            return () => clearTimeout(timer);
        }
    }, [value, duration]);
    
    return isAnimating;
};